export enum AdminPharmaciesTableColumnDataIndex {
  Name = "name",
  Adress = "adress",
  Active = "active",
  Options = "options",
}
